import { IBoardUserMeta } from '../types';

/**
 * default prefix "BOARD_USER_META"
 * */
export const AT_UPDATE = 'BOARD_USER_META__UPDATE';

export interface IUpdateAction {
    type: typeof AT_UPDATE;
    boardUserMeta: IBoardUserMeta;
}

export type TBoardUserMetaAction = (
    IUpdateAction
    );
